import {
  FilterMode,
  ContractObservationCreateMutationVariables,
  ContractObservation_OrderBy,
  ContractObservation,
  SortOrder,
  ContractObservation_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const contractObservationService = {
  createOne: buildCreateOne(
    (
        contractObservationCreateVariables: ContractObservationCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.contractObservationCreate(
          contractObservationCreateVariables
        );
        return result.contractObservationCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.contractObservationOne({ id });
    return result.contractObservationOne as ContractObservation;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: ContractObservation_OrderBy[] | null = null,
    filter: ContractObservation_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: ContractObservation_Filter | undefined;
    if (searchValue !== "") {
      where = {
        title: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.contractObservationListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ title: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.contractObservationListWithOffset
    ) as ContractObservation[];
    return { list, orderBy };
  },
};
